<template>
  <v-row>
    <v-col>
      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="dates"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateRangeText"
            label="Intervallum"
            prepend-icon="mdi-calendar"
            dense
            outlined
            color="red"
            background-color="grey lighten-2"
            item-color="red"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>

        <v-date-picker v-model="dates" :first-day-of-week="1" range scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(dates)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-col>
    
    <v-col>
      <v-select
        v-model="predefined"
        :items="predefinedItems"
        label="Előre meghatározott"
        dense
        outlined
        color="red"
        background-color="grey lighten-2"
        item-color="red"
        @change="applyPredefinedRange"
      ></v-select>
    </v-col>
  </v-row>
  
</template>
<script>
export default {
  data: () => ({
    modal: false,
    dates: [],
    predefined: 'E hónap',
    predefinedItems: ['Ma', 'E hét', 'E hónap', 'Idén']
  }),

  mounted() {
    this.applyPredefinedRange()
  },

  watch: {
    dates(val) {
      this.$emit("changeDates", val);
    },
  },

  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
  },

  methods: {
    applyPredefinedRange() {
      const today = new Date();
      let start, end;

      if (this.predefined === 'Ma') {
        start = new Date(today);
        end = new Date(today);
      }
      else if (this.predefined === 'E hét') {
        const day = today.getDay() || 7;
        start = new Date(today);
        start.setDate(today.getDate() - day + 1);
        end = new Date(start);
        end.setDate(start.getDate() + 6);
      } 
      else if (this.predefined === 'E hónap') {
        start = new Date(today.getFullYear(), today.getMonth(), 2);
        end = new Date(today.getFullYear(), today.getMonth() + 1, 1);
      } 
      else if (this.predefined === 'Idén') {
        start = new Date(today.getFullYear(), 0, 2);
        end = new Date(today.getFullYear(), 11, 32);
      }

      const format = (d) => d.toISOString().split('T')[0];
      this.dates = [format(start), format(end)];
    },
  }
};
</script>